import { Select, MenuItem, TextField, ListItemText, Checkbox, Divider } from '@mui/material';
import React, { useEffect, useRef, useState, useTransition} from 'react';
import Loader from './Loader';
import searchIcon from '../../assets/searchIcon.svg'
import styles from './searchableDropdown.module.scss'

const SearchableDropdown = ({ options = [], multiple, value, onChange, ...restProps }) => {
    let myOptions = options
    let defaultSelectedOptions = {}
    if (typeof options[0] !== "string") {
        myOptions = options.map(item => item.label)
    }
    if (multiple && value.length !== 0) {
        value.forEach(value => {
            defaultSelectedOptions[value] = true
        })
    }

    const searchRef = useRef()
    const [searchQuery, setSearchQuery] = useState('')
    const [isPending, startTransition] = useTransition()
    const [filteredOptions, setFilteredOptions] = useState({})
    const [selectedOptions, setSelectedOptions] = useState(defaultSelectedOptions)
    const stopImmediatePropagation = (e) => {
        e.stopPropagation();
        e.preventDefault();
    };
    
    const filter = (value) => {
        const newFilteredOptions = {}
        const lowerCaseValue = value?.toLowerCase()
        myOptions.forEach((option) => {
            if (option.toLowerCase().search(lowerCaseValue) !== -1) {
                newFilteredOptions[option] = true
            }
        })
        setFilteredOptions(newFilteredOptions)
    }
    const filterTextOnChange = (e) => {
        const searchText = e.target.value
        setSearchQuery(searchText)
        // startTransition helps to differentiate the urgent and non-urgent DOM updation
        // startTransition always carries the non-urgent DOM updation
        startTransition(() => filter(searchText))
        setTimeout(() => {
            searchRef.current.focus()
        }, 50)
    }
    const focusSearch = () => {
        setTimeout(() => {
            searchRef.current.focus()
        }, 100)
    }
    useEffect(() => {
        filter(searchQuery)
    }, [options])
    const multiProps = {}

    if (multiple) {
        multiProps.renderValue = (selected) => selected.join(', ')
        multiProps.onChange = (event) => {
            const values = event.target.value
            const newSelectedOptions = {}
            values.forEach(value => {
                newSelectedOptions[value] = true
            })
            setSelectedOptions(newSelectedOptions)
            onChange(event)
        }
    }
    return (
        <Select className={styles.selectHeight} onOpen={focusSearch} multiple={multiple} value={value} onChange={onChange} {...multiProps} {...restProps} MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}>
            <MenuItem
                className={styles.disableHover}
                onClickCapture={stopImmediatePropagation}
                onKeyDown={e => e.stopPropagation()}
                value=""
                disableRipple
            >
                <TextField 
                    fullWidth 
                    value={searchQuery}
                    onChange={filterTextOnChange} 
                    inputProps={{ ref: searchRef }} 
                    InputProps={{ startAdornment: <img src={searchIcon} className={styles.searchIcon} /> 
                    }} 
                />
            </MenuItem>
            {Object.keys(selectedOptions).map((option) => <MenuItem key={option} value={option}>
                {multiple && <Checkbox checked={value.indexOf(option) > -1} />}
                <ListItemText primary={option} />
            </MenuItem>)}
            {Object.keys(selectedOptions).length > 0 && <Divider />}
            {isPending ? <MenuItem><ListItemText><Loader size={32} /></ListItemText></MenuItem> : myOptions.map((option,index) => <MenuItem className={(selectedOptions[option] || !filteredOptions[option]) && styles.hide} key={option + index} value={option}>
                {multiple && <Checkbox checked={value.indexOf(option) > -1} />}
                <ListItemText primary={option} />
            </MenuItem>)}
        </Select>
    );
}

export default SearchableDropdown
